<template>
  <!-- <div class="container-login"> -->
    <form @submit.prevent="logIn">
      <v-container class="d-flex justify-center align-center fill-height">
        <v-sheet :elevation="10" width="400" rounded>
          <div class="d-flex justify-center pa-4">
            <img
              src="https://www.edisac.com/images/article_la/adint.png"
              alt="Logo Edisac"
              style="max-width: 100%; height: auto"
            />
          </div>

          <v-divider />

          <v-card-text>
            <v-form ref="formRef" @submit.prevent="logIn">
              <v-text-field
                v-model="login"
                variant="outlined"
                name="login"
                label="Nom d'utilisateur"
                type="text"
                :error="user && user.statut === 'username'"
                autocomplete="username"
                @keyup.enter="logIn"
              />

              <v-text-field
                v-model="password"
                variant="outlined"
                name="password"
                label="Mot de passe"
                :type="showPwd ? 'text' : 'password'"
                :append-inner-icon="showPwd ? 'mdi-eye-off' : 'mdi-eye'"
                :error="user && user.statut === 'password'"
                autocomplete="current-password"
                @click:append-inner="showPwd = !showPwd"
                @keyup.enter="logIn"
              />
            </v-form>
          </v-card-text>

          <v-card-actions class="d-flex flex-column align-stretch ga-2 px-4 pb-4">
            <small v-if="message" class="text-error">{{ message }}</small>

            <small v-if="user && user.statut === 'inactive'" class="text-error">
              Ce compte est désactivé, contactez l'administrateur.
            </small>

            <v-btn
              block
              color="#008080"
              size="large"
              :loading="loading"
              :disabled="!login || !password"
              type="submit"
              @click="logIn"
            >
              Login
            </v-btn>

            <a
              v-if="user && user.statut === 'password'"
              class="mdp"
              @click="sendEmail"
            >
              Mot de passe oublié ?
            </a>
          </v-card-actions>
        </v-sheet>
      </v-container>
    </form>

    <!-- Dialog mot de passe envoyé -->
    <v-dialog v-model="dialogLogIn" width="auto">
      <v-card max-width="400">
        <v-card-text>
          {{ user?.name }}, le mot de passe a été envoyé à l'adresse
          <b>{{ user?.email }}</b>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="#008080" @click="dialogLogIn = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  <!-- </div> -->
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'
import store from './store'
import router from './router'

/* ------------------------------------------------------------------
 * State
 * ------------------------------------------------------------------ */
const login        = ref('')
const password     = ref('')
const showPwd      = ref(false)
const loading      = ref(false)
const message      = ref('')
const user         = ref(null)
const dialogLogIn  = ref(false)
const formRef      = ref(null)

/* ------------------------------------------------------------------
 * Redirection selon le groupe
 * ------------------------------------------------------------------ */
const getURL = (u) => {
  switch (u.groupe) {
    case 'A':     return '/home'
    case 'B':     return '/validation'
    case 'C':     return '/reception'
    case 'AGENT': return '/negoce'
    default:      return '/home'
  }
}

/* ------------------------------------------------------------------
 * Login
 * ------------------------------------------------------------------ */
const logIn = async () => {
  // Nettoyage
  message.value = ''
  user.value    = null

  if (!login.value || !password.value) return

  loading.value = true
  try {
    const { data } = await axios.post('https://my.edisac.com/api/login', {
      username: login.value.toLowerCase().trim(),
      password: password.value
    })

    if (data.statut === 'connected') {
      store.commit('addUser', data)
      router.replace({ path: getURL(store.state.user) })
      return
    }

    if (data.statut === 'username') {
      message.value = `Le nom d'utilisateur <${login.value}> n'existe pas`
      user.value = data
      return
    }

    if (data.statut === 'password') {
      message.value = `${data.name}, le mot de passe n'est pas correct`
      user.value = data
      return
    }

    if (data.statut === 'inactive') {
      message.value = 'Ce compte est désactivé.'
      user.value = data
      return
    }

    message.value = 'Erreur inconnue, veuillez réessayer.'
  } catch (err) {
    console.error('❌ login', err)
    message.value = 'Erreur de connexion au serveur.'
  } finally {
    loading.value = false
  }
}

/* ------------------------------------------------------------------
 * Mot de passe oublié
 * ------------------------------------------------------------------ */
const sendEmail = async () => {
  try {
    await axios.post('https://my.edisac.com/api/mdp', user.value)
    dialogLogIn.value = true
  } catch (err) {
    console.error('❌ sendEmail', err)
  }
}
</script>

<style scoped>
.container-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}

.mdp {
  color: #008080;
  cursor: pointer;
  text-align: right;
  font-size: 0.85rem;
  transition: color 0.2s;
}

.mdp:hover {
  color: green;
  text-decoration: underline;
}
</style>